/* global System */
// register component(s) with react habitat

export default { OilCalculator: () => System.import('./index') }
